export const Service_GL = process.env.REACT_APP_SERVICE_TYPE === "global";
export const Service_CN =
  process.env.REACT_APP_COOKIE_DOMAIN === ".xiyouxi.com";

const data = [
  "vfun",
  "vfun-lounge",
  "billing",
  "vfun-stage",
  "vfun-lounge.stage",
  "billing-qa"
];

export function redirectURL(url: string, target: string, isLauncher: boolean) {
  // vfun, vfun-lounge, vfun-ground, billing,
  // vfun-stage, vfun-lounge.stage, vfun-ground-stage, billing-qa
  // 포함하면 self, 아님 blank
  let isDataIncluded = false;

  for (let i = 0; i < data.length; i++) {
    if (url.includes(data[i])) {
      isDataIncluded = true;
      break;
    }
  }

  if (isLauncher && !isDataIncluded) {
    window.app.vFunOpenWebBrowser(url);
  } else {
    window.open(url, target);
  }
}

export const dateFormType1 = (date: string): string => {
  const creat = new Date(date);
  let month = String(creat.getMonth() + 1).padStart(2, "0");
  let day = String(creat.getDate()).padStart(2, "0");

  return `${creat.getFullYear()}-${month}-${day}`;
};

export const LauncherLogin = (launcherlogin: boolean) => {
  if (launcherlogin) {
    console.log("launcher");
    window.app.vfunRequestLogin();
  }
};

export function msgRedirectURL(
  msg: string,
  url: string | undefined,
  target: string
) {
  alert(msg);
  window.open(url, target);
}

let xPos = 0;
let yPos = 0;
export function checkPosition() {
  xPos = window.screen.width / 2 - 500 / 2; // 가운데 정렬
  yPos = window.screen.height / 2 - 615 / 2;
}

export function naverAuthorizePopUp(url: string) {
  window.open(
    url,
    "",
    `width=500, height=615, left=
      ${xPos}
      , top=
      ${yPos}
      , menubar=yes, status=yes, titlebar=yes, resizable=yes`
  );
}

export const onCopy = async (
  url: string,
  impossible: string,
  possible: string
) => {
  try {
    // await navigator.clipboard.writeText(url);
    await window.navigator.clipboard.writeText(url);
    alert(possible);
    return true;
  } catch (error) {
    alert(impossible);
    return false;
  }
};

export function PopupShare(
  type: string,
  url: string,
  title: string,
  isLauncher: boolean
) {
  let strUrl = "";
  let openW = 768;
  let openH = 540;
  let Left = document.body.offsetWidth / 2 - openW / 2;
  let Top = document.body.offsetHeight / 2 - (openH + openH / 2);
  let strWindowFeatures = `width=${openW},height=${openH},left=${Left},top=${Top},resizable,scrollbars=yes,status=1`;

  console.log(type, "type");
  switch (type.toLowerCase()) {
    case "facebook":
      strUrl = "//www.facebook.com/sharer/sharer.php?u=" + url;
      break;
    case "twitter":
      strUrl = "//twitter.com/share?url=" + url;
      break;
    case "weibo":
      strUrl = "http://service.weibo.com/share/share.php?url=" + url; // + {URL}&title={TITLE}" + url;
      if (title !== "") {
        strUrl =
          strUrl +
          "&title=" +
          title +
          "&pic=//file.valofe.com/Valofe_file/web/meta/meta-fb-lostsaga-cn.jpg";
      }

      break;
    case "qq":
      strUrl =
        "http://connect.qq.com/widget/shareqq/iframe_index.html?url=" + url;
      if (title !== "") {
        strUrl = strUrl + "&title=" + title;
      }
      break;
    default:
      strUrl = window.location.href;
  }
  if (isLauncher) {
    window.app.vFunOpenWebBrowser(strUrl);
  } else {
    window.open(strUrl, type, strWindowFeatures);
  }
}
